import { render } from "./SeatClassCard.vue?vue&type=template&id=59b541d3&scoped=true"
import script from "./SeatClassCard.vue?vue&type=script&lang=js"
export * from "./SeatClassCard.vue?vue&type=script&lang=js"

import "./SeatClassCard.vue?vue&type=style&index=0&id=59b541d3&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b541d3"]])

export default __exports__